import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';

export const baseURI = 'configuracion/cuenta-de-la-entidad/';

/**
 * POST Cuenta de la Entidad
 * @param {object} values
 * @returns {Promise<Object>}
 */
export const postCuentaDeLaEntidad = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Información actualizada correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta de la Entidad
 * @param {number} id
 * @param {object} values
 * @returns {Promise<Object>}
 */
export const patchCuentaDeLaEntidad = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Información actualizada correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta de la Entidad
 * @param {number} id
 * @param {object} values
 * @returns {Promise<Object>}
 */
export const deleteCuentaDeLaEntidad = async (id, values) => {
  try {
    const response = await API.delete(`${baseURI}${id}`, values);
    onSuccess(response, 'Información actualizada correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Cuenta de la Entidad
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getCuentaDeLaEntidad = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return {};
  }
};

/**
 * GET Cuentas de la Entidad
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCuentasDeLaEntidad = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
